/* eslint-disable no-nested-ternary */
/* eslint-disable operator-linebreak */
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

type Props = {
  $islast?: boolean;
  $isfirst?: boolean;
  $subject: string;
}

type WrapperProps = {
  $type: 'next' | 'previous';
}

const buttonBaseStyles = css<Props>`
  background-color: #fff;
  font-family: 'Museo', sans-serif;
  font-size: 1.1875rem;
  color: ${({ theme }) => theme.colors.grayscale[50]};
  width: 60px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  position: relative;
  max-height: 60px;

  svg{
    margin: 0;
    padding: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.grayscale[30]};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover{
    background: ${({ theme }) => theme.colors.grayscale[100]};
  }

  @media (max-width: 768px){
    width: 50px;
    height: 50px;
  }
`;

export const NextButton = styled(NavLink)<Props>`
  ${buttonBaseStyles}
  border-radius: 12px 50px 50px 12px;

  svg{
    transform: rotate(90deg);
  }
`;

export const PreviousButton = styled(NavLink)<Props>`
  ${buttonBaseStyles}
  border-radius: 50px 8px 8px 50px;

  svg{
    transform: rotate(-90deg);
  }

`;

export const ButtonsBox = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ $isfirst }) => ($isfirst ? 'end' : 'space-between')};
  width: 100%;
  align-self: center;
  margin: 1.87rem 0;

  ${({ theme }) => theme.spacing.articleBody}

  @media (max-width: 600px){
    gap: 20px;
    margin-bottom: 0;
  }
`;

export const ButtonWrapper = styled.div<WrapperProps>`
  position: relative;
  max-width: 65px;
  background: linear-gradient(90deg, #FF7F50 0%, #FFD946 100%);
  padding: 2px;
  border-radius: ${({ $type }) => ($type === 'next' ? '12px 50px 50px 12px' : '50px 8px 8px 50px')};
`;
